import { OnSpotFileData } from '@/model/onSpot/OnSpot';
import { Icon } from '@/comp/icon/icon';

interface UploadFileListProps {
    fileList: OnSpotFileData[];
    setRemoveFile: (index: number) => void;
}

export const UploadFileList = ({ fileList, setRemoveFile }: UploadFileListProps) => {
    return (
        <>
            {fileList.map((item: OnSpotFileData, index: number) => (
                <div className="file" key={index}>
                    <span
                        className="icon-delete-file"
                        aria-label={`datei ${item.file.name} entfernen`}
                        onClick={() => setRemoveFile(index)}>
                        <Icon name="delete" ariaHidden />
                    </span>
                    <span className="file-name">{item.file.name}</span>
                </div>
            ))}
        </>
    );
};
